import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaymentRequestIgnoreList } from '../models/payment-request.model';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class PaymentRequestService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Payment Request', httpClient, toastrService, url);
  }

  // TODO:
  // url, subject, object, objectignorelist, afterpostcallback => direct call naar de base kunnen maken
  // postNow<Company>()('/payment-request', "Payment Request", paymentRequest, ignoreList, afterPostCallback)

  postPaymentRequest(paymentRequest: PaymentRequest, afterPostCallback?: Function, customMessage?: string) {
    return this.postNow('/payment-request', this.getBody(paymentRequest, PaymentRequestIgnoreList), afterPostCallback, customMessage);
  }

  updateStatuses(paymentRequestIds: number[], afterPutCallback?: Function, customMessage?: string) {
    return this.putNow('/payment-request/updatestatuses', this.getBody(paymentRequestIds, PaymentRequestIgnoreList), afterPutCallback, customMessage);
  }
}
